import { render, staticRenderFns } from "./FormerDirectorsContent.vue?vue&type=template&id=3202f3bc&scoped=true"
import script from "./FormerDirectorsContent.vue?vue&type=script&lang=js"
export * from "./FormerDirectorsContent.vue?vue&type=script&lang=js"
import style0 from "./FormerDirectorsContent.vue?vue&type=style&index=0&id=3202f3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3202f3bc",
  null
  
)

export default component.exports